<template>
  <v-layout row wrap>
    <v-flex xs12>
      <div>
        <connection-manager ref="connectionManager" v-model="connecting" />
        <div v-for="delivery of paginationState.deliveries">
          <div key="delivery.id">
            {{ delivery.originName }}
          </div>
        </div>
        <Pagination
          :totalPages.sync="paginationState.totalPages"
          :currentPage.sync="paginationState.currentPage"
          @pagechanged="pagechanged"
        ></Pagination>
      </div> </v-flex
  ></v-layout>
</template>

<script>
import Pagination from './Pagination.vue'
import ConnectionManager from './ConnectionManager'
export default {
  components: {
    Pagination,
    ConnectionManager
  },
  data() {
    return {
      paginationState: {
        deliveries: [],
        perPage: 5,
        currentPage: 1,
        totalPages: 0,
        totalCount: 0
      },
      loading: false,
      connecting: false
    }
  },
  methods: {
    getDeliveries(nextPage) {
      let that = this
      this.$refs.connectionManager.get(
        'deliveries-with-pagination',
        {
          onSuccess(response) {
            let dataReturned = response.data.data
            let paginator = response.data.paginator
            that.paginationState.deliveries = dataReturned
            that.paginationState.totalPages = paginator.totalPages
            that.paginationState.totalCount = paginator.totalCount
            that.paginationState.currentPage = paginator.currentPage
          }
        },
        {
          page: nextPage,
          size: this.paginationState.perPage,
          filter: 'DELIVERED'
        }
      )
    },
    pagechanged(nextPage) {
      this.getDeliveries(nextPage)
    },
    previousPage() {
      // const { currPage, page, size, todos } = this.paginationState
      // if (page > 1) {
      //   const newPage = page - 1
      //   const newCurrPage = paginate(todos, newPage, size)
      //   this.paginationState = {
      //     ...this.paginationState,
      //     page: newPage,
      //     currPage: newCurrPage
      //   }
      // }
    },
    nextPage() {
      // const { currPage, page, size, todos } = this.paginationState
      // if (page < currPage.totalPages) {
      //   const newPage = page + 1
      //   const newCurrPage = paginate(todos, newPage, size)
      //   this.paginationState = {
      //     ...this.paginationState,
      //     page: newPage,
      //     currPage: newCurrPage
      //   }
      // }
    }
  },
  mounted() {
    this.getDeliveries(this.paginationState.currentPage)
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/AdminDeliveries.vue